import WebLayout from "../../layout/WebLayout";
import PanelLayout from "../../layout/PanelLayout";
import { pipGetAccessToken } from "../../utils/pip";
import ContentManagement from "../../components/pages/ContentManagement";

const TermsofService = () => {
  const { token } = pipGetAccessToken();
  return token ? (
    <PanelLayout>
      {" "}
      <ContentManagement data="Terms of Service" />
    </PanelLayout>
  ) : (
    <WebLayout>
      {" "}
      <ContentManagement data="Terms of Service" />
    </WebLayout>
  );
};

export default TermsofService;
